/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DiaglabTestThreshold from './diaglab-test-threshold';
import DiaglabTestThresholdDetail from './diaglab-test-threshold-detail';
import DiaglabTestThresholdUpdate from './diaglab-test-threshold-update';
import DiaglabTestThresholdDeleteDialog from './diaglab-test-threshold-delete-dialog';

const DiaglabTestThresholdRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DiaglabTestThreshold />} />
    <Route path="new" element={<DiaglabTestThresholdUpdate />} />
    <Route path=":id">
      <Route index element={<DiaglabTestThresholdDetail />} />
      <Route path="edit" element={<DiaglabTestThresholdUpdate />} />
      <Route path="delete" element={<DiaglabTestThresholdDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DiaglabTestThresholdRoutes;
